import {
  ApiColorScheme,
  ResolvedTheme,
  SYSTEM_THEME_QUERY,
  ThemePreference,
} from './constants';

export function getSystemTheme(): ResolvedTheme {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return 'light';
  return window.matchMedia(SYSTEM_THEME_QUERY).matches ? 'dark' : 'light';
}

export function resolveTheme(theme: ThemePreference): ResolvedTheme {
  return theme === 'system' ? getSystemTheme() : theme;
}

export function themePreferenceFromApi(colorScheme?: string | null): ThemePreference | null {
  if (colorScheme === 'automatic') return 'system';
  if (colorScheme === 'light' || colorScheme === 'dark') return colorScheme;
  return null;
}

export function themePreferenceToApi(theme: ThemePreference): ApiColorScheme {
  return theme === 'system' ? 'automatic' : theme;
}
